import InlineMarkdown from './InlineMarkdown';

interface ITestPlanItem {
  action: string;
  expectedResult: string;
}

interface ITestPlanChecklistProps {
  items: ITestPlanItem[];
  emptyCopy: string;
}

/**
 * Renders the LLM-suggested pre-release test plan as a checklist of
 * (action → expected result) pairs. Indented `→` separator + bumped weight
 * on the expected result so the action/result pairing reads as one
 * structured step instead of "subtle hint follows action".
 */
const TestPlanChecklist = ({ items, emptyCopy }: ITestPlanChecklistProps) => {
  if (items.length === 0) {
    return <p className="text-fg-tertiary text-xs italic">{emptyCopy}</p>;
  }
  return (
    <ul className="flex flex-col gap-2">
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-2">
          <span className="border-border-secondary mt-1 inline-block h-3.5 w-3.5 shrink-0 border" aria-hidden="true" />
          <div className="flex flex-col gap-1">
            <span className="text-fg-primary text-sm">
              <InlineMarkdown text={item.action} />
            </span>
            <span className="text-fg-secondary flex items-start gap-1.5 pl-2 text-xs">
              <span className="text-fg-quaternary shrink-0" aria-hidden="true">
                →
              </span>
              <span className="text-fg-primary font-medium">
                <InlineMarkdown text={item.expectedResult} />
              </span>
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default TestPlanChecklist;
